import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

export default class extends Controller {
  static values = {
    content: String
  }

  connect() {
    this.instance = tippy(this.element, {
      content: this.contentValue,
      allowHTML: true,
      interactive: true,
      // 'mouseenter focus' for desktop, 'click' for touch devices is handled by default,
      // but we can be explicit to ensure the best mobile experience:
      trigger: 'mouseenter focus click',
      theme: 'light-border', // Optional: you can style this in CSS
      maxWidth: 250,
    })
  }

  disconnect() {
    if (this.instance) this.instance.destroy()
  }
}
